import { normalizeStorefront } from './storefront'

export function defaultStorefront() {
  return normalizeStorefront({})
}

export function defaultFeatures() {
  return {
    orders: true,
    inventory: true,
    analytics: true,
    marketing: false,
    payments: true,
  }
}

export function emptyOrganizationForm() {
  return {
    name: '',
    country: '',
    currency: 'USD',
    status: 'inactive',
    businessDescription: '',
    owner: { firstName: '', lastName: '', email: '' },
    phone: '',
    contactStreet: '',
    contactPostcode: '',
    contactRegion: '',
    contactCountry: '',
    storefront: defaultStorefront(),
    features: defaultFeatures(),
  }
}
